<template>
  <div>
    <div class="p-seo__graph flex">
      <div class="graphArea">
        <div class="bgGraphBase">
          <div class="bgGraphHidden">
            <span
              class="resultGraph"
              :style="{ width: barWidth.all + '%' }"
            ></span>
          </div>
          <span class="min">0</span>
          <span class="max">{{ all.total }}</span>
        </div>
      </div>
      <div class="volume flex">
        <span>{{ all.clear }}</span
        ><span> / {{ all.total }}</span>
      </div>
    </div>
    <ul class="p-seo__graph small">
      <li class="flex">
        <div class="graphArea">
          <div class="title">一般的なSEO問題</div>
          <div class="bgGraphBase">
            <div class="bgGraphHidden">
              <span
                class="resultGraph"
                :style="{
                  width: barWidth.generalIssue + '%'
                }"
              ></span>
            </div>
          </div>
        </div>
        <div class="volume">
          <span>{{ data.generalIssue.clear }}</span
          >/ {{ data.generalIssue.total }}
        </div>
      </li>
      <li class="flex">
        <div class="graphArea">
          <div class="title">スピード最適化</div>
          <div class="bgGraphBase">
            <div class="bgGraphHidden">
              <span
                class="resultGraph"
                :style="{
                  width: barWidth.speedOptimization + '%'
                }"
              ></span>
            </div>
          </div>
        </div>
        <div class="volume">
          <span>{{ data.speedOptimization.clear }}</span
          >/ {{ data.speedOptimization.total }}
        </div>
      </li>
      <li class="flex">
        <div class="graphArea">
          <div class="title">サーバー＆セキュリティ</div>
          <div class="bgGraphBase">
            <div class="bgGraphHidden">
              <span
                class="resultGraph"
                :style="{
                  width: barWidth.serverAndSecurity + '%'
                }"
              ></span>
            </div>
          </div>
        </div>
        <div class="volume">
          <span>{{ data.serverAndSecurity.clear }}</span
          >/ {{ data.serverAndSecurity.total }}
        </div>
      </li>
      <li class="flex">
        <div class="graphArea">
          <div class="title">モバイルユーザビリティ</div>
          <div class="bgGraphBase">
            <div class="bgGraphHidden">
              <span
                class="resultGraph"
                :style="{
                  width: barWidth.mobileUsability + '%'
                }"
              ></span>
            </div>
          </div>
        </div>
        <div class="volume">
          <span>{{ data.mobileUsability.clear }}</span
          >/ {{ data.mobileUsability.total }}
        </div>
      </li>
      <li class="flex">
        <div class="graphArea">
          <div class="title">高度なSEO</div>
          <div class="bgGraphBase">
            <div class="bgGraphHidden">
              <span
                class="resultGraph"
                :style="{
                  width: barWidth.advancedSeo + '%'
                }"
              ></span>
            </div>
          </div>
        </div>
        <div class="volume">
          <span>{{ data.advancedSeo.clear }}</span
          >/ {{ data.advancedSeo.total }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    isAnimate: {
      type: Boolean,
      required: false
    }
  },

  data() {
    return {
      barWidth: {
        all: 0,
        generalIssue: 0,
        speedOptimization: 0,
        serverAndSecurity: 0,
        mobileUsability: 0,
        advancedSeo: 0
      },
      timeout: null
    };
  },

  computed: {
    all() {
      let clear = 0;
      let total = 0;
      for (const key in this.data) {
        clear += this.data[key].clear;
        total += this.data[key].total;
      }
      return {
        clear: clear,
        total: total
      };
    }
  },

  mounted() {
    if (this.isAnimate) {
      this.$nextTick(() => {
        this.timeout = setTimeout(() => {
          this.update();
        }, 100);
      });
    } else {
      this.update();
    }
  },

  destroyed() {
    clearTimeout(this.timeout);
  },

  methods: {
    update() {
      if (this.all.clear && this.all.total) {
        this.barWidth.all = (this.all.clear / this.all.total) * 100;
      } else {
        this.barWidth.all = 0;
      }
      for (const key in this.barWidth) {
        if (this.data.hasOwnProperty(key)) {
          const d = this.data[key];
          if (d.clear && d.total) {
            this.barWidth[key] = (d.clear / d.total) * 100;
          } else {
            this.barWidth[key] = 0;
          }
        }
      }
    }
  }
};
</script>
